module.exports = __webpack_public_path__ + "static/media/interior5.da295120.png";